// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import axios from 'axios'
import moment from 'moment'
import 'babel-polyfill'
/*头部-底部*/
import headMenu from '@/views/head.vue'
import foo from '@/views/footer.vue'
/*文档头部*/
import docHeadMenu from '@/views/doc_head.vue'

import 'font-awesome/css/font-awesome.min.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@/app.less'
import '@/assets/css/css.css'
import '@/assets/css/animate.min.css'

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.$http = axios;

import router from './router'
import store from "./store"
import App from './App'

Vue.component('headMenu', headMenu);
Vue.component('docHeadMenu', docHeadMenu);
Vue.component('foo', foo);

new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
});

Vue.filter('dateformat', function(dataStr, pattern = 'YYYY-MM-DD') {
	return moment(dataStr).format(pattern)
})
//点击跳转定位在顶部
router.beforeEach((to, from, next) => {
//	location.reload();
	// chrome
	document.body.scrollTop = 0
	// firefox
	document.documentElement.scrollTop = 0
	// safari
	window.pageYOffset = 0
	next()
})



// WEBPACK FOOTER //
// ./src/main.js